module.exports = __webpack_public_path__ + "img/blue50.10376a86.png";